import React from 'react';
import styled from 'styled-components';
import DeleteIcon from '../../../images/common/i_delete.svg';
import WatchIcon from '../../../images/common/i_watch.svg';

// 혈압 기록 컴퍼넌트

const ContentWrap = styled.div`
    display: block;
    border-radius: var(--radius-16);
    background-color: var(--color-white);
`;

const InnerBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--sp-08);
    padding: var(--sp-16);
`;
const TopBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    & .status {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 20px;
        padding: 0 10px;
        border-radius: 100px;
        background-color: var(--color-main-25);
        font-size: var(--mo-fz-xsm);
        color: var(--color-main-5) ;
        font-weight: 700;
    }
    & .status[data-status="caution"] {
        content: "주의";
        background-color: #FFE8D4;
        color: #FF8D29;
    }
    & .status[data-status="danger"] {
        content: "위험";
        background-color: #FADCDC;
        color: #E55151;
    }
    & .delt-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width:24px;
        height: 24px;
        border-radius: 8px;
        background-color: var(--color-main-30);
        transform: scale(1);
        transition: transform .4s;
    }
    & .delt-btn:active {
        transform: scale(.9);
    }
    & .source {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        font-size: var(--mo-fz-sm);
        color: var(--color-main-gray-5);
        font-weight: 700;
    }
    & .source img {
        width: 1.6rem;
        height: 1.6rem;
    }
`;
const MiddleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 3.2rem;
    & .mid-box strong {
        font-size: var(--mo-fz-sm);
        color: var(--color-main-gray-5);
        font-weight: 700;
    }
    & .mid-box p {
        display: flex;
        align-items: center;
        gap: 3px;
        font-size: var(--mo-fz-sm);
        color: var(--color-main-gray-10);
        font-weight: 400;
    }
    & .mid-box p span {
        font-size: var(--mo-fz-smd);
        color: var(--color-main-black);
        font-weight: 700;
    }
`;
const BottomBox = styled.div`
    & span {
        font-size: var(--mo-fz-sm);
        color: var(--color-main-gray-10);
        font-weight: 400; 
    }
`;



/**
 * @param source 'watch' 면 워치(삼성 헬스 모니터)로 잰 기록.
 *               연계 기록이라 사용자가 지울 수 없다 — 지워도 다음 동기화에 다시 들어온다.
 */
const BloodPressureRecordBox = ({systolic, diastolic, result ,date, time, source, usrBrssrHistId, onDelete }) => {

    const isWatch = source === 'watch';

    return (
        <ContentWrap>
            <InnerBox>
                <TopBox>
                {
                  (result === 'N') ? <span className='status' data-status="normal">정상</span>
                : (result === 'C') ? <span className='status' data-status="caution">주의</span>
                : <span className='status' data-status="danger">위험</span>
                }
                
                    {isWatch ? (
                        <span className='source'>
                            <img src={WatchIcon} alt="" />
                            워치 연동 기록
                        </span>
                    ) : (
                        <button className='delt-btn' onClick={() => onDelete(usrBrssrHistId)}>
                            <img src={DeleteIcon} alt="삭제" />
                        </button>
                    )}
                </TopBox>
                <MiddleBox>
                        <div className='mid-box'>
                            <strong>수축기</strong>
                            <p>
                                <span>{systolic}</span>mmHg 
                            </p>
                        </div>
                        <div className='mid-box'>
                            <strong>이완기</strong>
                            <p>
                                <span>{diastolic}</span>mmHg 
                            </p>
                        </div>
                </MiddleBox>    
                <BottomBox>
                        {/* 워치 기록은 하루 여러 건이 정상이라 시간까지 보여준다. */}
                        <span>{time ? `${date} ${time}` : date}</span>
                </BottomBox>
            </InnerBox>
        </ContentWrap>
    );
};

export default BloodPressureRecordBox;